import { COMPONENT } from '../../../../../utils/component-validations';
import Super from '../../../core/base.gjs';
import styles from './trigger.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

const METADATA = {
  component: 'Spds::Action::Button::Dropdown::Trigger',
  description: 'Trigger button for dropdown menu',
  meta: {
    button: {
      type: COMPONENT,
      description: 'Button component to render as trigger',
    },
  },
  name: 'Dropdown Trigger',
};

export default class SpdsActionButtonDropdownTrigger extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-action-button-dropdown-trigger';
  classesToMapToArgs = ['disabled', 'open'];
  styles = styles;

  <template>
    <@button
      @disabled={{@disabled}}
      @fitContent={{true}}
      @size={{@size}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      aria-haspopup="menu"
      class={{this.classes}}
      data-test-spds-action-button-dropdown-trigger
      ...attributes
    >
      {{#if @icon}}
        {{svgJar
          @icon
          class="spds-action-button-dropdown-trigger-icon"
          data-test-spds-action-button-trigger-icon=""
        }}
      {{/if}}
      {{yield}}
      {{svgJar "dropdown-caret" class="spds-action-button-dropdown-trigger-caret"}}
    </@button>
  </template>
}

export const ACTION_BUTTON_DROPDOWN_TRIGGER_METADATA = SpdsActionButtonDropdownTrigger.metadata;
